/// <amd-module name="Widgets/SprintBurndownWidget/SprintBurndownWidgetDataProvider" />
import { TeamSettingsIteration } from "Dashboards/Clients/contracts/Work";
import * as WorkRestClient from "Dashboards/Clients/Work";
import { IProjectData } from "Tfs/Platform/Page";
import * as TfsWidgetContext from "Tfs/Widget/Context";
import { IVssPageContext } from "VSS/Platform/Context";
import { isFeatureFlagEnabled } from "VSS/Platform/Feature";
import { routeUrl } from "VSS/Platform/Location";

export interface ISprintMetadata {
    name: string;
    startDate: Date;
    finishDate: Date;
}

interface IBurndownChartOptions {
    Width: number;
    Height: number;
    ShowDetails: boolean;
    Title: string;
}

export class SprintBurndownWidgetDataProvider {
    private projectData: IProjectData;
    private isBoardChartImagesRestApiDisabled: boolean;

    constructor(private pageContext: IVssPageContext) {
        this.projectData = TfsWidgetContext.getProject(pageContext);
        this.isBoardChartImagesRestApiDisabled = isFeatureFlagEnabled(this.pageContext, "WebAccess.Agile.DisableBoardChartImagesRestApi", false);
    }

    public getProjectData(): IProjectData {
        return this.projectData;
    }

    public getChartImageUrl(width: number, height: number, showDetails: boolean, teamId: string, iteration: TeamSettingsIteration): string {
        if (this.isBoardChartImagesRestApiDisabled) {
            const chartOptions: IBurndownChartOptions = {
                Width: width,
                Height: height,
                ShowDetails: showDetails,
                Title: ""
            };
            return routeUrl(this.pageContext, "ms.vss-dashboards-web.api-burndown-teamchart-mvc", {
                project: this.projectData.id,
                team: teamId,
                chartOptions: JSON.stringify(chartOptions),
                includeVersion: "true",
                teamId: teamId,
                iterationPath: iteration.path
            });
        }
        return routeUrl(this.pageContext, "ms.vss-dashboards-web.api-burndown-teamchart-rest", {
            project: this.projectData.id,
            team: teamId,
            iterationId: iteration.id,
            width: width.toString(),
            height: height.toString(),
            showDetails: showDetails.toString()
        });
    }

    public async getSprintMetadata(teamId: string): Promise<TeamSettingsIteration[]> {
        const client = this.pageContext.getRestClient<WorkRestClient.IWorkRestClient>("Dashboards-Work.IWorkRestClient");
        const teamContext = {
            project: this.projectData.id,
            projectId: this.projectData.id,
            team: teamId,
            teamId: teamId
        };
        return client.getTeamIterations(teamContext, "current");
    }
}
